
import React from 'react';

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "/app/node_modules/@storybook/addon-docs/dist/shims/mdx-react-shim.mjs";
import {Meta} from "@storybook/addon-docs/blocks";
import Github from "./assets/github.svg";
import Discord from "./assets/discord.svg";
import Youtube from "./assets/youtube.svg";
import Tutorials from "./assets/tutorials.svg";
import Styling from "./assets/styling.png";
import Context from "./assets/context.png";
import Assets from "./assets/assets.png";
import Docs from "./assets/docs.png";
import Share from "./assets/share.png";
import FigmaPlugin from "./assets/figma-plugin.png";
import Testing from "./assets/testing.png";
import Accessibility from "./assets/accessibility.png";
import Theming from "./assets/theming.png";
import AddonLibrary from "./assets/addon-library.png";
export const RightArrow = () => _jsx("svg", {
  viewBox: "0 0 14 14",
  width: "8px",
  height: "14px",
  style: {
    marginLeft: '4px',
    display: 'inline-block',
    shapeRendering: 'inherit',
    verticalAlign: 'middle',
    fill: 'currentColor',
    'path fill': 'currentColor'
  },
  children: _jsx("path", {
    d: "m11.1 7.35-5.5 5.5a.5.5 0 0 1-.7-.7L10.04 7 4.9 1.85a.5.5 0 1 1 .7-.7l5.5 5.5c.2.2.2.5 0 .7Z"
  })
});
function _createMdxContent(props) {
  const _components = {
    code: "code",
    h1: "h1",
    p: "p",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(Meta, {
      title: "Configure your project"
    }), "\n", _jsxs("div", {
      className: "sb-container",
      children: [_jsxs("div", {
        className: "sb-section-title",
        children: [_jsx(_components.h1, {
          id: "configure-your-project",
          children: "Configure your project"
        }), _jsx(_components.p, {
          children: "Because Storybook works separately from your app, you'll need to configure it for your specific stack and setup. Below, explore guides for configuring Storybook with popular frameworks and tools. If you get stuck, learn how you can ask for help from our community."
        })]
      }), _jsxs("div", {
        className: "sb-section",
        children: [_jsxs("div", {
          className: "sb-section-item",
          children: [_jsx("img", {
            src: Styling,
            alt: "A wall of logos representing different styling technologies"
          }), _jsx("h4", {
            className: "sb-section-item-heading",
            children: "Add styling and CSS"
          }), _jsx("p", {
            className: "sb-section-item-paragraph",
            children: "Like with web applications, there are many ways to include CSS within Storybook. Learn more about setting up styling within Storybook."
          }), _jsxs("a", {
            href: "https://storybook.js.org/docs/configure/styling-and-css/?renderer=angular&ref=configure",
            target: "_blank",
            children: ["Learn more", _jsx(RightArrow, {})]
          })]
        }), _jsxs("div", {
          className: "sb-section-item",
          children: [_jsx("img", {
            src: Context,
            alt: "An abstraction representing the composition of data for a component"
          }), _jsx("h4", {
            className: "sb-section-item-heading",
            children: "Provide context and mocking"
          }), _jsx("p", {
            className: "sb-section-item-paragraph",
            children: "Often when a story doesn't render, it's because your component is expecting a specific environment or context (like a theme provider) to be available."
          }), _jsxs("a", {
            href: "https://storybook.js.org/docs/writing-stories/decorators/?renderer=angular&ref=configure#context-for-mocking",
            target: "_blank",
            children: ["Learn more", _jsx(RightArrow, {})]
          })]
        }), _jsxs("div", {
          className: "sb-section-item",
          children: [_jsx("img", {
            src: Assets,
            alt: "A representation of typography and image assets"
          }), _jsxs("div", {
            children: [_jsx("h4", {
              className: "sb-section-item-heading",
              children: "Load assets and resources"
            }), _jsxs("p", {
              className: "sb-section-item-paragraph",
              children: ["To link static files (like fonts) to your projects and stories, use the\n", _jsx(_components.code, {
                children: "staticDirs"
              }), " configuration option to specify folders to load when\nstarting Storybook."]
            }), _jsxs("a", {
              href: "https://storybook.js.org/docs/configure/images-and-assets/?renderer=angular&ref=configure",
              target: "_blank",
              children: ["Learn more", _jsx(RightArrow, {})]
            })]
          })]
        })]
      })]
    }), "\n", _jsxs("div", {
      className: "sb-container",
      children: [_jsxs("div", {
        className: "sb-section-title",
        children: [_jsx(_components.h1, {
          id: "do-more-with-storybook",
          children: "Do more with Storybook"
        }), _jsx(_components.p, {
          children: "Now that you know the basics, let's explore other parts of Storybook that will improve your experience. This list is just to get you started. You can customise Storybook in many ways to fit your needs."
        })]
      }), _jsx("div", {
        className: "sb-section",
        children: _jsxs("div", {
          className: "sb-features-grid",
          children: [_jsxs("div", {
            className: "sb-grid-item",
            children: [_jsx("img", {
              src: Docs,
              alt: "A screenshot showing the autodocs tag being set, pointing a docs page being generated"
            }), _jsx("h4", {
              className: "sb-section-item-heading",
              children: "Autodocs"
            }), _jsx("p", {
              className: "sb-section-item-paragraph",
              children: "Auto-generate living,\ninteractive reference documentation from your components and stories."
            }), _jsxs("a", {
              href: "https://storybook.js.org/docs/writing-docs/autodocs/?renderer=angular&ref=configure",
              target: "_blank",
              children: ["Learn more", _jsx(RightArrow, {})]
            })]
          }), _jsxs("div", {
            className: "sb-grid-item",
            children: [_jsx("img", {
              src: Share,
              alt: "A browser window showing a Storybook being published to a chromatic.com URL"
            }), _jsx("h4", {
              className: "sb-section-item-heading",
              children: "Publish to Chromatic"
            }), _jsx("p", {
              className: "sb-section-item-paragraph",
              children: "Publish your Storybook to review and collaborate with your entire team."
            }), _jsxs("a", {
              href: "https://storybook.js.org/docs/sharing/publish-storybook/?renderer=angular&ref=configure#publish-storybook-with-chromatic",
              target: "_blank",
              children: ["Learn more", _jsx(RightArrow, {})]
            })]
          }), _jsxs("div", {
            className: "sb-grid-item",
            children: [_jsx("img", {
              src: FigmaPlugin,
              alt: "Windows showing the Storybook plugin in Figma"
            }), _jsx("h4", {
              className: "sb-section-item-heading",
              children: "Figma Plugin"
            }), _jsx("p", {
              className: "sb-section-item-paragraph",
              children: "Embed your stories into Figma to cross-reference the design and live\nimplementation in one place."
            }), _jsxs("a", {
              href: "https://storybook.js.org/docs/sharing/design-integrations/?renderer=angular&ref=configure#embed-storybook-in-figma-with-the-plugin",
              target: "_blank",
              children: ["Learn more", _jsx(RightArrow, {})]
            })]
          }), _jsxs("div", {
            className: "sb-grid-item",
            children: [_jsx("img", {
              src: Testing,
              alt: "Screenshot of tests passing and failing"
            }), _jsx("h4", {
              className: "sb-section-item-heading",
              children: "Testing"
            }), _jsx("p", {
              className: "sb-section-item-paragraph",
              children: "Use stories to test a component in all its variations, no matter how\ncomplex."
            }), _jsxs("a", {
              href: "https://storybook.js.org/docs/writing-tests/?renderer=angular&ref=configure",
              target: "_blank",
              children: ["Learn more", _jsx(RightArrow, {})]
            })]
          }), _jsxs("div", {
            className: "sb-grid-item",
            children: [_jsx("img", {
              src: Accessibility,
              alt: "Screenshot of accessibility tests passing and failing"
            }), _jsx("h4", {
              className: "sb-section-item-heading",
              children: "Accessibility"
            }), _jsx("p", {
              className: "sb-section-item-paragraph",
              children: "Automatically test your components for a11y issues as you develop."
            }), _jsxs("a", {
              href: "https://storybook.js.org/docs/writing-tests/accessibility-testing/?renderer=angular&ref=configure",
              target: "_blank",
              children: ["Learn more", _jsx(RightArrow, {})]
            })]
          }), _jsxs("div", {
            className: "sb-grid-item",
            children: [_jsx("img", {
              src: Theming,
              alt: "Screenshot of Storybook in light and dark mode"
            }), _jsx("h4", {
              className: "sb-section-item-heading",
              children: "Theming"
            }), _jsx("p", {
              className: "sb-section-item-paragraph",
              children: "Theme Storybook's UI to personalize it to your project."
            }), _jsxs("a", {
              href: "https://storybook.js.org/docs/configure/theming/?renderer=angular&ref=configure",
              target: "_blank",
              children: ["Learn more", _jsx(RightArrow, {})]
            })]
          })]
        })
      })]
    }), "\n", _jsxs("div", {
      className: "sb-addon",
      children: [_jsxs("div", {
        className: "sb-addon-text",
        children: [_jsx("h4", {
          children: "Addons"
        }), _jsx("p", {
          className: "sb-section-item-paragraph",
          children: "Integrate your tools with Storybook to connect workflows."
        }), _jsxs("a", {
          href: "https://storybook.js.org/addons/?ref=configure",
          target: "_blank",
          children: ["Discover all addons", _jsx(RightArrow, {})]
        })]
      }), _jsx("div", {
        className: "sb-addon-img",
        children: _jsx("img", {
          src: AddonLibrary,
          alt: "Integrate your tools with Storybook to connect workflows."
        })
      })]
    }), "\n", _jsxs("div", {
      className: "sb-section sb-socials",
      children: [_jsxs("div", {
        className: "sb-section-item",
        children: [_jsx("img", {
          src: Github,
          alt: "Github logo",
          className: "sb-explore-image"
        }), _jsx(_components.p, {
          children: "Join our contributors building the future of UI development."
        }), _jsxs("a", {
          href: "https://github.com/storybookjs/storybook",
          target: "_blank",
          children: ["Star on GitHub", _jsx(RightArrow, {})]
        })]
      }), _jsxs("div", {
        className: "sb-section-item",
        children: [_jsx("img", {
          src: Discord,
          alt: "Discord logo",
          className: "sb-explore-image"
        }), _jsxs("div", {
          children: [_jsx(_components.p, {
            children: "Get support and chat with frontend developers."
          }), _jsxs("a", {
            href: "https://discord.gg/storybook",
            target: "_blank",
            children: ["Join Discord server", _jsx(RightArrow, {})]
          })]
        })]
      }), _jsxs("div", {
        className: "sb-section-item",
        children: [_jsx("img", {
          src: Youtube,
          alt: "Youtube logo",
          className: "sb-explore-image"
        }), _jsxs("div", {
          children: [_jsx(_components.p, {
            children: "Watch tutorials, feature previews and interviews."
          }), _jsxs("a", {
            href: "https://www.youtube.com/@chromaticui",
            target: "_blank",
            children: ["Watch on YouTube", _jsx(RightArrow, {})]
          })]
        })]
      }), _jsxs("div", {
        className: "sb-section-item",
        children: [_jsx("img", {
          src: Tutorials,
          alt: "A book",
          className: "sb-explore-image"
        }), _jsx("p", {
          children: "Follow guided walkthroughs on for key workflows."
        }), _jsxs("a", {
          href: "https://storybook.js.org/tutorials/?ref=configure",
          target: "_blank",
          children: ["Discover tutorials", _jsx(RightArrow, {})]
        })]
      })]
    }), "\n", _jsx("style", {
      children: `
.sb-container {
  margin-bottom: 48px;
}

.sb-section {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 20px;
}

img {
  object-fit: cover;
}

.sb-section-title {
  margin-bottom: 32px;
}

.sb-section a:not(h1 a, h2 a, h3 a) {
  font-size: 14px;
}

.sb-section-item, .sb-grid-item {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.sb-section-item-heading {
  padding-top: 20px !important;
  padding-bottom: 5px !important;
  margin: 0 !important;
}
.sb-section-item-paragraph {
  margin: 0;
  padding-bottom: 10px;
}

.sb-chevron {
  margin-left: 5px;
}

.sb-features-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 32px 20px;
}

.sb-socials {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}

.sb-socials p {
  margin-bottom: 10px;
}

.sb-explore-image {
  max-height: 32px;
  align-self: flex-start;
}

.sb-addon {
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  background-color: #EEF3F8;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  background: #EEF3F8;
  height: 180px;
  margin-bottom: 48px;
  overflow: hidden;
}

.sb-addon-text {
  padding-left: 48px;
  max-width: 240px;
}

.sb-addon-text h4 {
  padding-top: 0px;
}

.sb-addon-img {
  position: absolute;
  left: 345px;
  top: 0;
  height: 100%;
  width: 200%;
  overflow: hidden;
}

.sb-addon-img img {
  width: 650px;
  transform: rotate(-15deg);
  margin-left: 40px;
  margin-top: -72px;
  box-shadow: 0 0 1px rgba(255, 255, 255, 0);
  backface-visibility: hidden;
}

@media screen and (max-width: 800px) {
  .sb-addon-img {
    left: 300px;
  }
}

@media screen and (max-width: 600px) {
  .sb-section {
    flex-direction: column;
  }

  .sb-features-grid {
    grid-template-columns: repeat(1, 1fr);
  }

  .sb-socials {
    grid-template-columns: repeat(2, 1fr);
  }

  .sb-addon {
    height: 280px;
    align-items: flex-start;
    padding-top: 32px;
    overflow: hidden;
  }

  .sb-addon-text {
    padding-left: 24px;
  }

  .sb-addon-img {
    right: 0;
    left: 0;
    top: 130px;
    bottom: 0;
    overflow: hidden;
    height: auto;
    width: 124%;
  }

  .sb-addon-img img {
    width: 1200px;
    transform: rotate(-12deg);
    margin-left: 0;
    margin-top: 48px;
    margin-bottom: -40px;
    margin-left: -24px;
  }
}
`
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
